
import layerEvents from "../utils/layerEvents";
import { Button, Col, Row, Dropdown, Form} from "react-bootstrap";
import Select from "react-select";
import { PencilSimple,Lightning, Windmill, BatteryCharging, BatteryFull, Spiral, Ruler, Crosshair, X, Info, Eye, Trash, DotsThreeVertical, Wind, Calculator, Warning, CircleNotch, Plus, Bulldozer,ArrowsOutLineVertical,ArrowsOutLineHorizontal, Bridge   } from "@phosphor-icons/react";
import DataTable from 'react-data-table-component';
import atlasApi from "../utils/atlasapi";
import {format_power} from "../utils/functions";
import EditNow from "../components/EditNow";
import DoNowButton from "../components/DoNowButton";
import ReactDOM from "react-dom/client";
import measureMode from "../utils/measureMode";
import TurfArea from '@turf/area';
import TurfBuffer from '@turf/buffer';
import TurfLength from '@turf/length';
import LineToPolygon from '@turf/line-to-polygon';
import TurfCenterOfMass				from '@turf/center-of-mass';

import MidPoint from '@turf/midpoint';
import {point, lineString} from '@turf/helpers';
import {formatArea, formatDistance} from "../utils/functions";
import MapboxDraw from "@mapbox/mapbox-gl-draw";
import drawTheme from "../utils/drawUtilsTheme";


class ToolMeasure {

	tabIndex			= null;
	contextMenu			= null;
	toolPanelSelector	= "measureModePanel";
	length				= 0;
	area				= 0;
	precision			= 1;
	closed				= 0;
	
	_distSource			= 'distances';
	_distLayer			= 'distances_layer';
	_areaSource			= 'area';
	_areaLayer			= 'area_layer';
	
	constructor(p) {
		this.parent = p;
		this.draw	= p.draw.draw;
		this.tc		= p;
	}

	init(){
		this.setEventHandlers();
		this.tc.map.getContainer().classList.add("cursor-measure");
		this.openToolPanel();
		this.stackDrawLayers();
		this.addAreaLayer();
		this.addMeasureLayer();
		
	}
	exit(){
//		if(this.parent.serviceBar.current)
//			this.parent.serviceBar.current.clear(this.tabIndex);
//		this.tabIndex = null;
		this.removeEventHandlers();
		this.reset();
		this.closeToolPanel();
		this.unsetStyle();
		this.removeMeasureLayer();
		this.removeAreaLayer();
		this.parent.map.getContainer().classList.remove("cursor-measure");
	}
	setEventHandlers(){
		
		if(!this.parent)
			return;
		
		this.tc.map.on('click', this.handleClick);
		
		this.tc.map.on('draw.create', this.handleCreate);
		this.tc.map.on('draw.selectionchange', this.handleSelectionChange);
		this.tc.map.on('mousemove',		this.calculate);
		

	}
	removeEventHandlers(){
		if(!this.parent)
			return;
		
		this.tc.map.off('click', this.handleClick);
		this.tc.map.off('mousemove',		this.calculate);
		this.tc.map.off('draw.create', this.handleCreate);
		this.tc.map.off('draw.selectionchange', this.handleSelectionChange);
	}
	
	stackDrawLayers = () =>{
		
		drawTheme.forEach((l)=>{
			if(this.tc.map.getLayer(l.id+".cold"))
				this.tc.map.moveLayer(l.id+".cold");
			if(this.tc.map.getLayer(l.id+".hot"))
				this.tc.map.moveLayer(l.id+".hot");
		});
		
	}
	handleClick = (e) => {
		
		const mode = this.draw.getMode();
		var edit = false;
		var features = this.tc.map.queryRenderedFeatures(e.point);
		
		if(features && features.length && ['mapbox-gl-draw-cold', 'mapbox-gl-draw-hot'].includes(features[0].source)){
			var edit = true;
		}
		
		
		if(this.draw.getMode() == 'measure_mode' || this.measuring || edit)
			return;
		if(this.area)
			return;
		
		this.measuring = true;
		
		this.draw.changeMode('measure_mode', {
			startCoordinate: [e.lngLat.lng, e.lngLat.lat],
		});
		this.setStyle();
	}
	handleCreate = (e)=>{
		this.measuring = false;
		//if(this.isClosedPoly(e.features[0]))
		//	this.draw.changeMode('simple_select');
		
	}
	handleSelectionChange = (e) => {	
		
		if(e.features.length)
			this.measuring = false;

	}
	handleFinish = ()=>{
		this.draw.changeMode('simple_select');
		
	}
	handleContinue = () => {
		var line = this.draw.get('added_measure');
		this.measuring = true;
		this.draw.changeMode('measure_mode', {
			feature: line,
		});
	}
	handleOnClose = (e)=>{
		this.tc.exit();
		
	}
	reset  = ()=>{
		this.measuring = false;
		this.length = 0;
		this.area = 0;
		this.closed = 0;
		this.draw.delete('added_measure');
		this.display();
		this.removeMeasureLayer();
		this.removeAreaLayer();
		this.addAreaLayer();
		this.addMeasureLayer();
		
	}
	atFirstCoord = (e) => {
		return (
			e &&
			e.featureTarget && 
			e.featureTarget.properties && 
			e.featureTarget.properties.meta == 'vertex' && 
			e.featureTarget.properties.coord_path == 0
		);
	}
	isClosedPoly = (line) => {
		
		const last = line.geometry.coordinates.length-1;
		
		return this.closed = (line.geometry.coordinates[0][0] == line.geometry.coordinates[last][0] && line.geometry.coordinates[0][1] == line.geometry.coordinates[last][1]);
		
	}
	calculate = (e) => {
		

		var line = this.draw.get('added_measure');
		const mode = this.draw.getMode();
	
		if(
			!line || 
			!line.geometry ||
			line.geometry?.coordinates?.length < 2
		)
			return;
		
		var features = [];
		var polys = [];
		for(var idx = 1; idx<line.geometry.coordinates.length; idx++){
			
			const midpoint = MidPoint(point(line.geometry.coordinates[idx-1]), point(line.geometry.coordinates[idx]));
			const dist = TurfLength(lineString([line.geometry.coordinates[idx-1], line.geometry.coordinates[idx]]), { units: 'meters' });
			
			midpoint.properties.distance = formatDistance(dist);
			
			features.push(midpoint);
			
		}
		if(line.geometry?.coordinates?.length > 2 && ((this.measuring && this.atFirstCoord(e)) || (!this.measuring && this.isClosedPoly(line))) ){
			
			const poly = LineToPolygon(line);
			
			polys.push(poly);
			
			const area = formatArea(this.area = TurfArea(poly));
			var center = TurfCenterOfMass(poly);
			center.properties.distance = area;
			center.properties.type = 'area';
			features.push(center);
		}

		
		
		
		this.tc.map.getSource(this._areaSource).setData({
				type: 'FeatureCollection',
				features: polys
		});
			
		this.tc.map.getSource(this._distSource).setData({
			type: 'FeatureCollection',
			features: features
		});
		
		this.precision = this.tc.map.getZoom() > 12 ? 3 : 1;
		
		// Calculate length and area
		this.length = TurfLength(line, { units: 'meters' });
		this.display()
	}

	closeToolPanel() {
		
		if(!this.tc)
			return;
		var a = false;
		if(a = this.tc.map.getContainer().querySelector("."+this.toolPanelSelector)){
			a.remove();
		}
		
		
	}
	openToolPanel = ()=>{
		
		var wrp = document.createElement("div");
		wrp.className = this.toolPanelSelector;
		
		this.closeToolPanel();
		
		this.tc.map.getContainer().appendChild(wrp);
		
		this.toolPanel = ReactDOM.createRoot(wrp);
		this.toolPanel.render(this.render());
		
	}
	addMeasureLayer(){
		this.removeMeasureLayer();
		this.tc.map.addSource(this._distSource, {
			type: 'geojson',
			data: {
				type: 'FeatureCollection',
				features: []
			}
		});

		this.tc.map.addLayer({
			'id': this._distLayer,
			'type': 'symbol',
			'source': this._distSource,
			'paint': {
				'text-opacity': 1,
				'text-color': measureMode.user_color,
				'text-halo-color': "#ffffff",
				'text-halo-width': 3,
				'text-halo-blur': 0
			},
			'layout': {
				'text-field': ['get', 'distance'], //This will get "t" property from your geojson
				'text-rotation-alignment': "auto",
				'text-allow-overlap': true,
				'text-anchor': "center",
				'text-justify': "center",
				'text-size': 14,
				'symbol-placement': 'point',
				'text-keep-upright': true,
				'text-ignore-placement': true
			}
		});
	}
	addAreaLayer(){
		this.removeAreaLayer();
		this.tc.map.addSource(this._areaSource, {
			type: 'geojson',
			data: {
				type: 'FeatureCollection',
				features: []
			}
		});

		this.tc.map.addLayer({
			'id': this._areaLayer,
			'type': 'fill',
			'source': this._areaSource,
			'paint': {

				'fill-color': measureMode.user_color,
				'fill-opacity': .5
			},
			'layout': {

			}
		});
//		this.tc.map.addLayer({
//			'id': this._areaLayer,
//			'type': 'fill',
//			'source': this._areaSource,
//			'paint': {
//				'text-opacity': 1,
//				'text-color': measureMode.user_color,
//				'text-halo-color': "#ffffff",
//				'text-halo-width': 3,
//				'text-halo-blur': 0,
//				'fill-color': measureMode.user_color,
//				'fill-opacity': .5
//			},
//			'layout': {
//				'text-field': ['get', 'area'], //This will get "t" property from your geojson
//				'text-rotation-alignment': "auto",
//				'text-allow-overlap': true,
//				'text-anchor': "center",
//				'text-justify': "center",
//				'text-size': 14,
//				'text-keep-upright': true,
//				'text-ignore-placement': true
//			}
//		});
	}
	
	removeMeasureLayer(){
		const l = this._distLayer;
		const b = this._distSource;
		if(this.tc.map.getLayer(l)){
			this.tc.map.removeLayer(l);
		}
		if(this.tc.map.getSource(b)){
			this.tc.map.removeSource(b);
		}
	}
	removeAreaLayer(){
		const l = this._areaLayer;
		const b = this._areaSource;
		if(this.tc.map.getLayer(l)){
			this.tc.map.removeLayer(l);
		}
		if(this.tc.map.getSource(b)){
			this.tc.map.removeSource(b);
		}
	}
	
	
	
	setStyle(){
		
		this.tc.map.setPaintProperty('gl-draw-polygon-and-line-vertex-stroke-inactive.hot', 'circle-radius', 10);
		this.tc.map.setPaintProperty('gl-draw-polygon-and-line-vertex-inactive.hot', 'circle-radius', 8);
		this.tc.map.setPaintProperty('gl-draw-point-active.hot', 'circle-radius', 8);
		
		this.tc.map.setPaintProperty('gl-draw-polygon-and-line-vertex-stroke-inactive.cold', 'circle-radius', 10);
		this.tc.map.setPaintProperty('gl-draw-polygon-and-line-vertex-inactive.cold', 'circle-radius', 8);
		this.tc.map.setPaintProperty('gl-draw-point-active.cold', 'circle-radius', 8);
		
	}
	
	unsetStyle(){
		
		this.tc.map.setPaintProperty('gl-draw-polygon-and-line-vertex-stroke-inactive.hot', 'circle-radius', 7);
		this.tc.map.setPaintProperty('gl-draw-polygon-and-line-vertex-inactive.hot', 'circle-radius', 5);
		this.tc.map.setPaintProperty('gl-draw-point-active.hot', 'circle-radius', 5);
		
		this.tc.map.setPaintProperty('gl-draw-polygon-and-line-vertex-stroke-inactive.cold', 'circle-radius', 7);
		this.tc.map.setPaintProperty('gl-draw-polygon-and-line-vertex-inactive.cold', 'circle-radius', 5);
		this.tc.map.setPaintProperty('gl-draw-point-active.cold', 'circle-radius', 5);
		
	}
	
	display(){
		this.toolPanel.render(this.render());
	}
	render(){
		
		return (
			<div className="measureTool-panel" >
				<Row>
					<Col xs="12 pb-2 title">
						<b>Measure distance</b>
						{/*<span onClick={(e)=>{this.tc.exit()}} className="btn btn-close btn-sm float-end"><X size={16} /></span>*/}
					</Col>

					
					<div className="my-3" >
						{!this.length && 
							<Col xs="12">Click in map to start measuring...</Col>
						}
						{!!this.length && !this.closed && 
							<>
								<Col xs="12">
									Total distance
								</Col>
								<Col xs="12">
									<b>{formatDistance(this.length, this.precision)}</b>
								</Col>
							</>
						}
						{!!this.area && !!this.closed && 
							<>
								<Col xs="12">
									Total area
								</Col>
								<Col xs="12">
									<b>{formatArea(this.area)}</b>
								</Col>
							</>
						}
					</div>
					
					{!!this.length && 
						<>
						
							<Col xs="8">
								{!this.closed && 
									<>
									{this.measuring &&
										<Button variant="primary" onClick={this.handleFinish}>Finish</Button>
									}
									{!this.measuring &&
										<Button variant="primary" onClick={this.handleContinue}>Continue</Button>
									}
									</>
								}
							</Col>
						
						<Col xs="4 text-end">
							<Button className="ms-auto px-2" variant="outline-primary" onClick={this.reset}><Trash size={16} /></Button>
						</Col>
						</>
					}
				</Row>
			</div>	
		);
	}
}

export { ToolMeasure};